import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(employeeId, isCollaborator, relativeId) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();

  let relativeQueryParams = searchQueryParams;

  let searchQueryEmployeeData = new URLSearchParams({
    ...searchOptions,
    // status: 0,
  }).toString();

  if (employeeId) {
    relativeQueryParams =
      relativeQueryParams +
      "&" +
      new URLSearchParams({ employeeId }).toString();
  }

  let apiGetEmployeePath = `/employee?${searchQueryEmployeeData}`;
  if (isCollaborator && relativeId) {
    const params =
      relativeQueryParams +
      "&" +
      new URLSearchParams({ employeeId: relativeId }).toString();
    apiGetEmployeePath = `/relativeRegisterForm/app/myRelative?${params}`;
  }

  // Fetch constant data concurrently
  const [relativeData, employeeData] = await Promise.all([
    clientAPI("get", `/relativeRegisterForm/myRelative?${relativeQueryParams}`),
    clientAPI("get", apiGetEmployeePath),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    relativeData: relativeData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
    employeeData: employeeData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
    participants: employeeData?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          fullName: item.fullName,
          code: item.code,
        },
      }),
      {}
    ),
  };
}

export function useCategories(
  employeeId,
  shouldFetch,
  isCollaborator,
  relativeId
) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categoriesRelative", employeeId, isCollaborator, relativeId],
    queryFn: () => fetchConstantData(employeeId, isCollaborator, relativeId),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
